// Shared by every app that needs to know which region (and so which locale) the user chose.
export const REGION_COOKIE_NAME = "locale";

const SECONDS_IN_A_DAY = 60 * 60 * 24;
const DAYS_IN_A_YEAR = 365;

export const REGION_COOKIE_MAX_AGE_SECONDS = SECONDS_IN_A_DAY * DAYS_IN_A_YEAR;
